import React from 'react';
import classnames from 'classnames';
import styles from '../styles/components/message.module.scss';
import { AffiliateIcon } from './icons/affiliate-icon';

export const Message = React.memo(
  ({ renderAs: Component = 'div', type = 'positive', className, children, iconName }) => (
    <Component className={classnames(styles.container, className)}>
      <div className={styles.icon}>
        <AffiliateIcon name={iconName} />
      </div>
      <div className={styles.label}>
        <span className={styles.text}>{children}</span>
      </div>
    </Component>
  )
);
